import { post } from './axios'

export const updateLocalTicketsData = async () => {
    await post('Support/GetRequest',{offset: 0,limit: 5000}).then(({ data }) => {
        if(data.isSuccess){
            const tickets = []
            data.data.map(item => tickets.push({
                id: item.id,
                count: item.supportTickets.filter(message => [83,103].includes(message.issuerRole)).length || 0
            }))
            localStorage.setItem('tickets',JSON.stringify(tickets))
        }
    })
    return calculateNotSawTickets()
}

export const updateSawTicketsData = (id,count) => {
    const oldSawTickets = localStorage.getItem('stickets') ? JSON.parse(localStorage.getItem('stickets')) : []
    if(oldSawTickets.length){
        const index = oldSawTickets.findIndex(item => item.id == id)
        if(index != -1)
            oldSawTickets[index].count = count
        else
            oldSawTickets.push({
                id,
                count
            })
    }else
        oldSawTickets.push({
            id,
            count
        })
    localStorage.setItem('stickets',JSON.stringify(oldSawTickets))
}

export const calculateNotSawTickets = () => {
    const tickets = localStorage.getItem('tickets') ? JSON.parse(localStorage.getItem('tickets')) : []
    const sawTickets = localStorage.getItem('stickets') ? JSON.parse(localStorage.getItem('stickets')) : []
    let notSaw = 0
    tickets.map(ticket => {
        const saw = sawTickets.find(t => t.id == ticket.id)
        if(saw)
            notSaw += ticket.count - saw.count
        else
            notSaw += ticket.count
    })
    return notSaw
}